import { BASE_URL } from '@/shared/lib/const/env'
import { TProduct } from '@/shared/types/product-types'

import { ProductSchema, ProductSchemaProps } from '../../json-ld/ProductSchema/ProductSchema'

interface ProductSchemaNodeProps {
	data: TProduct
	categoryName: string
	reviews?: ProductSchemaProps['reviews']
}

export const ProductSchemaNode = (props: ProductSchemaNodeProps) => {
	const { data, categoryName, reviews } = props

	// Товар в наличии, если ORDER_TYPE не равен HIDE_BUY или ARCHIVE
	const isInStock = data.ORDER_TYPE !== 'HIDE_BUY' && data.ORDER_TYPE !== 'ARCHIVE'

	const productSchemaInfo: ProductSchemaProps = {
		productData: {
			code: data.KOD,
			title: data.TITLE,
			description: data.SEO?.ELEMENT_META_DESCRIPTION,
			images: (data.IMAGES ?? []).map(imagePath => `${BASE_URL}${imagePath}`),
			article: data.ARTICLE,
			price: data?.PRICE?.VALUE,
			brand: data.PROPERTIES?.osnovnye_parametry?.GROUP_PROPERTIES?.PROIZVODITEL?.values?.[0]?.NAME ?? ``,
			isInStock: isInStock
		},
		category: categoryName,
		reviews
	}

	return (
		<script
			type="application/ld+json"
			data-label="ProductSchema"
			dangerouslySetInnerHTML={{ __html: JSON.stringify(ProductSchema(productSchemaInfo)) }}
		/>
	)
}
